// extracted by mini-css-extract-plugin
export default {"loading":"PDFGenerationButton_loading__HeWQk","rotation":"PDFGenerationButton_rotation__ebA5u"};